export const IntoOpenSeaApprovalColumns = [
  {
    title: "客户名称",
    width: 96,
    align: "center",
    ellipsis: true,
    resizable: true,
    scopedSlots: { customRender: "customerName" },
    // dataIndex: "customerName",
    key: "customerName"
  },
  {
    title: "发起者",
    width: 48,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "displayName",
    key: "displayName"
  },
  {
    title: "状态",
    width: 48,
    align: "center",
    ellipsis: true,
    resizable: true,
    scopedSlots: { customRender: "status" },
    // dataIndex: "displayName",
    key: "status"
  },
  {
    title: "审批内容",
    width: 144,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "content",
    key: "content"
  },
  {
    title: "发起日期",
    width: 80,
    ellipsis: true,
    align: "center",
    resizable: true,
    scopedSlots: { customRender: "insertTime" },
    key: "insertTime"
  },
  {
    title: "操作",
    fixed: "right",
    align: "center",
    width: 64,
    className: "erp-table-operation-col",
    key: "operation",
    scopedSlots: { customRender: "operation" }
  }
]

export const IntoOpenSeaCopyInColumns = [
  {
    title: "客户名称",
    width: 96,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "customerName",
    scopedSlots: { customRender: "customerName" },
    key: "customerName"
  },
  {
    title: "发起者",
    width: 48,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "displayName",
    key: "displayName"
  },
  {
    title: "状态",
    width: 48,
    align: "center",
    ellipsis: true,
    resizable: true,
    scopedSlots: { customRender: "status" },
    // dataIndex: "displayName",
    key: "status"
  },
  {
    title: "审批内容",
    width: 144,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "content",
    key: "content"
  },
  {
    title: "发起日期",
    width: 80,
    ellipsis: true,
    align: "center",
    resizable: true,
    scopedSlots: { customRender: "insertTime" },
    key: "insertTime"
  },
  {
    title: "操作",
    fixed: "right",
    align: "center",
    width: 64,
    className: "erp-table-operation-col",
    key: "operation",
    scopedSlots: { customRender: "operation" }
  }
]
